import { ComponentType } from 'react'
import { AboutNav } from 'views/common/about-nav'
import { TextHero } from 'components/TextHero'
import { Intro } from './intro'
import { Tabs } from './tabs'

export const AgentsMobile: ComponentType = () => (
  <>
    <TextHero title="Conoce Mérida, Descubre Yucatán" subtitle="Asesores Certificados" />
    <AboutNav />
    {/*<Intro />*/}
    <Tabs />
  </>
)
